import { Splide } from '../vendor/splide.esm.js';
import { AutoScroll } from '../vendor/splide-extension-auto-scroll.esm.js';
import { Expander } from './expander';

const sliders = {
	elem: {
		bestSliders: document.querySelectorAll('.tbd .splide'),
		brandSliders: document.querySelectorAll('.brand-slider__carousel'),
		cardSliders: document.querySelectorAll('.carousel--cards'),
		daySliders: document.querySelectorAll('.aditl'),
		inspirationSliders: document.querySelectorAll('.carousel--inspiration'),
		mediaSliders: document.querySelectorAll('.carousel--media'),
		recipeSliders: document.querySelectorAll('.carousel--recipes'),
		testimonialSliders: document.querySelectorAll('.carousel--testimonials'),
		activateButton: document.querySelectorAll('.carousel__activate')
	},

	mql: {
		large: window.matchMedia('(min-width: 1024px)')
	},

	options: {
		defaults: {
			arrowPath: 'M12.02 0L0 0L13.1 20L0 40L12.02 40L25.11 20L12.02 0z',
			autoHeight: true,
			gap: '14px',
			mediaQuery: 'min',
			pagination: false,
			speed: 400,
			breakpoints: {
				1024: {
					gap: '20px'
				}
			}
		},
		bestSlider: {
			autoHeight: true,
			focus: 0,
			perMove: 1,
			perPage: 1,
			start: 0,
			gap: '0px',
			type: 'slide',
			classes: {
		  		arrows: 'splide__arrows tbd__arrows',
  				arrow : 'splide__arrow tbd__arrow icon-btn',
  				prev  : 'splide__arrow--prev tbd__arrow--prev',
  				next  : 'splide__arrow--next tbd__arrow--next'
			},
			breakpoints: {
				768: {
					gap: '16px',
					perPage: 2,
					perMove: 1
				},
				1024: {
					arrows: false,
					perPage: 4,
					perMove: 1
				}
			}			
		},		
		brandSlider: {
			arrows: false,
			autoHeight: true,
			fixedWidth: 'var(--logo-width)',
			gap: '20px',
			perPage: 3,
			type   : 'loop',
			autoScroll: {
				speed: 0.75
			}
		},
		cardSlider: {
			autoHeight: true,
			focus: 0,
			padding: { left: 0, right: '08.2vw' },
			perMove: 1,
			perPage: 1,
			start: 0,
			type: 'slide',
			classes: {
		  		arrows: 'splide__arrows carousel__arrows',
  				arrow : 'splide__arrow carousel__arrow icon-btn',
  				prev  : 'splide__arrow--prev carousel__arrow--prev',
  				next  : 'splide__arrow--next carousel__arrow--next',
			},
			breakpoints: {
				768: {
					perPage: 2,
					perMove: 1,
				},
				1024: {
					perPage: 3,
					perMove: 1,
					padding: 0
				}
			}
		},
		daySlider: {
			autoHeight: true,
			focus: 0,
			perMove: 1,
			perPage: 1,
			start: 0,
			gap: '-44px',
			type: 'slide',
			classes: {
		  		arrows: 'splide__arrows aditl__arrows',
  				arrow : 'splide__arrow aditl__arrow icon-btn',
  				prev  : 'splide__arrow--prev aditl__arrow--prev',
  				next  : 'splide__arrow--next aditl__arrow--next',
			}
		},
		inspirationSlider: {
			autoHeight: true,
			focus: 0,
			perMove: 1,
			perPage: 1,
			start: 0,
			type: 'slide',
			classes: {
		  		arrows: 'splide__arrows carousel__arrows',
  				arrow : 'splide__arrow carousel__arrow icon-btn',
				prev  : 'splide__arrow--prev carousel__arrow--prev',
				next  : 'splide__arrow--next carousel__arrow--next',
			}
		},
		mediaSlider: {
			autoHeight: true,
			autoWidth: true,
			focus: 0,
			padding: { left: 0, right: '08.2vw' },
			start: 0,
			classes: {
		  		arrows: 'splide__arrows carousel__arrows',
  				arrow : 'splide__arrow carousel__arrow icon-btn',
  				prev  : 'splide__arrow--prev carousel__arrow--prev',
  				next  : 'splide__arrow--next carousel__arrow--next',
			}
		},
		recipeSlider: {
			autoHeight: true,
			focus: 0,
			padding: { left: 0, right: '08.2vw' },
			perMove: 1,
			perPage: 1,
			start: 0,
			type: 'slide',
			classes: {
		  		arrows: 'splide__arrows carousel__arrows',
  				arrow : 'splide__arrow carousel__arrow icon-btn',
				prev  : 'splide__arrow--prev carousel__arrow--prev',
				next  : 'splide__arrow--next carousel__arrow--next',
			},
			breakpoints: {
				768: {
					perPage: 2,
					perMove: 2,
				},
				1024: {
					perPage: 3,
					perMove: 1,
					padding: 0,
					arrows: false
				}
			}
		},
		testimonialSlider: {
			autoHeight: true,
			focus: 0,
			perMove: 1,
			perPage: 1,
			start: 0,
			type: 'slide',
			classes: {
		  		arrows: 'splide__arrows carousel__arrows',
  				arrow : 'splide__arrow carousel__arrow icon-btn',
				prev  : 'splide__arrow--prev carousel__arrow--prev',
				next  : 'splide__arrow--next carousel__arrow--next',
			}
		}
	},

	splide: [],

	init() {
		Splide.defaults = sliders.options.defaults;

		// Best Dairy Slider
		if(sliders.elem.bestSliders.length > 0) {
			sliders.elem.bestSliders.forEach((element) => {
				sliders.setupSlider(element, 'best');
			});
		}

		// Brand Sliders
		if(sliders.elem.brandSliders.length > 0) {
			sliders.elem.brandSliders.forEach((element) => {
				sliders.setupSlider(element, 'brand');
			});
		}

		// Card Sliders
		if(sliders.elem.cardSliders.length > 0) {
			sliders.elem.cardSliders.forEach((element) => {
				sliders.setupSlider(element, 'card');
			});
		}

		// A Day In The Life Slider
		if(sliders.elem.daySliders.length > 0) {
			if(!sliders.mql.large.matches) {
				sliders.elem.daySliders.forEach((element) => {
					sliders.setupSlider(element, 'day');
				});
			};
		}

		// Testimonial Sliders
		if(sliders.elem.inspirationSliders.length > 0) {
			sliders.elem.inspirationSliders.forEach((element) => {
				sliders.setupSlider(element, 'inspiration');
			});
		}

		// Media Sliders
		if(sliders.elem.mediaSliders.length > 0) {
			sliders.elem.mediaSliders.forEach((element) => {
				sliders.setupSlider(element, 'media');
			});
		}

		// Recipe Sliders
		if(sliders.elem.recipeSliders.length > 0) {
			sliders.elem.recipeSliders.forEach((element) => {
				sliders.setupSlider(element, 'recipe');
			});
		}

		// Testimonial Sliders
		if(sliders.elem.testimonialSliders.length > 0) {
			sliders.elem.testimonialSliders.forEach((element) => {
				sliders.setupSlider(element, 'testimonial');
			});
		}

		// Activation Buttons
		if(sliders.elem.activateButton.length > 0) {
			sliders.elem.activateButton.forEach((element) => {
				element.addEventListener('click', sliders.slideIntoView);
			});
		}

		sliders.bindUIActions();
	},

	setupSlider(element, type) {

		switch(type) {
			case 'brand':
				sliders.splide.unshift(new Splide(element, {
					...sliders.options.brandSlider,
					...(element.classList.contains('brand-slider__carousel--reverse') ? { direction: 'rtl' } : {})
				}).mount({ AutoScroll }));
				break;
			case 'best':
				sliders.splide.unshift(new Splide(element, sliders.options.bestSlider ).on('move', sliders.updateProgress).on('move', sliders.updateImage).mount());
				break;
			case 'day':
				sliders.splide.unshift(new Splide(element, sliders.options.daySlider ).on('move', sliders.updateProgress).on('move', sliders.updateBackground).mount());
				break;
			case 'inspiration':
				sliders.splide.unshift(new Splide(element, sliders.options.testimonialSlider ).on('ready move', sliders.updateProgress).mount());
				break;
			case 'media':
				sliders.splide.unshift(new Splide(element, sliders.options.mediaSlider )
					.on('move', sliders.updateProgress)
					.on('click', (slide) => { this.splide[0].go(slide.index); })
					.mount({}, Expander));
				break;
			case 'recipe':
				sliders.splide.unshift(new Splide(element, sliders.options.recipeSlider ).on('move', sliders.updateProgress).mount());
				break;
			case 'testimonial':
				sliders.splide.unshift(new Splide(element, sliders.options.testimonialSlider ).on('ready move', sliders.updateProgress).mount());
				break;
			default:
				sliders.splide.unshift(new Splide(element, sliders.options.cardSlider).on('ready move', sliders.updateProgress).mount());
				break;
		}
	},

	bindUIActions() {
		let autoplayControls = document.querySelectorAll('.brand-slider .toggle-btn');
		if (autoplayControls.length > 0) {
			autoplayControls.forEach(function(element) {
				element.addEventListener('click', sliders.pauseAutoplay);
			});
		}

		sliders.updateProgress(); // Because mount event does not fire
	},

	pauseAutoplay(event) {
		event.preventDefault();
		let pressed = event.target.getAttribute('aria-pressed');
		let label = event.target.getAttribute('aria-label');
		pressed = (pressed === 'true') ? 'false' : 'true';
		label = label.indexOf('Play') > -1 ? label.replace('Play', 'Pause') : label.replace('Pause', 'Play');
		event.target.setAttribute('aria-pressed', pressed);
		event.target.setAttribute('aria-label', label);
		if (pressed === 'true') {
			sliders.splide.forEach(function(element) {
				if(element.Components.AutoScroll) {
					element.Components.AutoScroll.pause();
				}
			});
		} else {
			sliders.splide.forEach(function(element) {
				if(element.Components.AutoScroll) {
					element.Components.AutoScroll.play();
				}
			});
		}
	},

	slideIntoView(event) {
		let slide = parseInt(event.target.dataset['slide']);
		let carousel = event.target.closest('.splide');
		sliders.splide.forEach(function(element) {
			if(element.root === carousel) {
				element.go(slide);
			} 
		});
	},

	updateProgress() {
		sliders.splide.forEach(function(element) {
			let buttonPrev = element.root.querySelector('.splide__arrow--prev');
			let buttonNext = element.root.querySelector('.splide__arrow--next');
			let bar = element.root.querySelector('.carousel__progress-bar, .aditl__progress-bar, .tbd__progress-bar');
			let counter = element.root.querySelector('.carousel__counter, .aditl__counter, .tbd__counter');
			if(buttonPrev !== null) {
				if(element.index !== 0) {
					buttonPrev.removeAttribute('disabled');
				} else {
					buttonPrev.setAttribute('disabled', true);
				}
			}
			if(buttonNext !== null) {
				if(element.index !== (element.length - 1)) {
					buttonNext.removeAttribute('disabled');
				} else {
					buttonNext.setAttribute('disabled', true);
				}
			}
			if(bar !== null) {
				bar.style.width = String( 100 * ((element.index + 1) / element.length )) + '%';
				counter.textContent = `${element.index + 1}/${element.length}`;
			}
		});
	},

	updateBackground() {
		sliders.splide.forEach(function(element) {
			if (element.root.classList.contains('aditl')) {
				let background = element.root.querySelector('.splide__slide:nth-child(' + (element.index + 1) + ')').dataset.background;
				let selected = element.root.querySelector('.aditl__bg-image--selected');
				if (selected !== null) {
					selected.classList.remove('aditl__bg-image--selected');
				}
				element.root.querySelector('.aditl__bg-image[data-background="' + background + '"]').classList.add('aditl__bg-image--selected');
			}
		});
	},

	updateImage() {
		sliders.splide.forEach(function(element) {
			if (element.root.classList.contains('tbd__carousel')) {
				let active = element.root.querySelector('.splide__slide:nth-child(' + (element.index + 1) + ') .tbd__card').id;
				let images = document.querySelectorAll('.tbd__image');
				images.forEach(function(element) {
					element.classList.remove('tbd__image--active');
					if(element.dataset.tab === active) {
						element.classList.add('tbd__image--active');
					}
				});
			}
		});
	}	
};

export { sliders };
